import { render, staticRenderFns } from "./PlatformCallback.vue?vue&type=template&id=20a82aec&scoped=true&"
import script from "./PlatformCallback.vue?vue&type=script&lang=js&"
export * from "./PlatformCallback.vue?vue&type=script&lang=js&"
import style0 from "./PlatformCallback.vue?vue&type=style&index=0&id=20a82aec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a82aec",
  null
  
)

export default component.exports